<template>
<section id="resume" class="section resume">
  <div class="heading">
    <h2>Summary</h2>
    <p data-aos="fade-up">Skills</p>
  </div>
  <div class="container-fluid">
    <div class="row">

      <div class="col-12 col-lg-6 mb-2">
        <h3 data-aos="fade-up">My Education</h3>
        <div class="list-education" >
          <div class="card" data-aos="fade-up">
          <div class="card-body">
            <div class="date"><span>2014/2015 - 2019/2020</span></div>
            <h2>Information Technology Engineering</h2>
            <span class="sp-text">Damascus University</span>
            <p>I hold a information engineering certificate, the specialty of software engineering and systems and information security.</p>
          </div>
          </div>
          <div class="card" data-aos="fade-up">
            <div class="card-body">
              <div class="date"><span>2021/08/01 - 2021/08/17</span></div>
              <h2>Digital Marketing</h2>
              <span class="sp-text">Skills from Google</span>
              <p>I hold a digital marketing certificate from Google Skills after successfully passing the exams.</p>
            </div>
          </div>
          <div class="card" data-aos="fade-up">
            <div class="card-body">
              <div class="date"><span>2014 - Until Now</span></div>
              <h2>Self learning</h2>
              <span class="sp-text">Online self education</span>
              <p>
                I learn everything new in the field of informatics engineering to keep abreast of developments in the world of technologies.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 mb-2">
        <h3 data-aos="fade-up">My Experience</h3>
        <div class="list-experience">
          <div class="card" data-aos="fade-up">
            <div class="card-body">
              <div class="date"><span>2018/2019 - 2019/2020</span></div>
              <h2>Graduation Project</h2>
              <span class="sp-text">ELCOME Company</span>
              <p>
                Fair use policy for the Internet , The project aims to develop a system that allows the Internet service provider to apply the policies of distributing the Internet package fairly among users.
              </p>
            </div>
          </div>
          <div class="card" data-aos="fade-up">
            <div class="card-body">
              <div class="date"><span>2021/06/01 - 2021/08/01</span></div>
              <h2>Data validator</h2>
              <span class="sp-text">Subul Company</span>
              <p>
                Data validation means checking the accuracy and quality of source data before using, importing or otherwise processing data. Different types of validation can be performed depending on destination constraints or objectives. Data validation is a form of data cleansing.
              </p>
            </div>
          </div>
          <div class="card" data-aos="fade-up">
            <div class="card-body">
              <div class="date"><span>2022/05/01 - 2022/09/18</span></div>
              <h2>Full Stack Developer</h2>
              <span class="sp-text">AlSadeem Company</span>
              <p>
                Back-End : Engz api in nest js framework.
              </p>
              <p>Front-End : Ezar Group in vue cli framework.</p>
            </div>
          </div>
          <div class="card" data-aos="fade-up">
            <div class="card-body">
              <div class="date"><span>2017 - Until Now</span></div>
              <h2>Freelancer</h2>
              <span class="sp-text">IT free work</span>
              <p>
                I adopt all the requirements and needs of the market from private and public software projects, as I provide a service for developing websites, mobile and desktop applications, and solving software problems, and tutoring for university students.
              </p>
            </div>
          </div>
        </div>
      </div>


      <div class="col-md-6 my-4" data-aos="fade-up" >
          <p class="text-light fw-500 text-start mb-2">Java <span class="float-end">95%</span></p>
          <div class="progress progress-sm bg-dark mb-4">
            <div class="progress-bar" role="progressbar" style="width: 95%;max-width: 95%;" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <p class="text-light fw-500 text-start mb-2">Java Fx <span class="float-end">90%</span></p>
          <div class="progress progress-sm bg-dark mb-4">
            <div class="progress-bar" role="progressbar" style="width: 90%;max-width: 90%;" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <p class="text-light fw-500 text-start mb-2">Php <span class="float-end">85%</span></p>
          <div class="progress progress-sm bg-dark mb-4">
            <div class="progress-bar" role="progressbar" style="width: 85%;max-width: 85%;" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <p class="text-light fw-500 text-start mb-2">Dart <span class="float-end">85%</span></p>
          <div class="progress progress-sm bg-dark mb-4">
            <div class="progress-bar" role="progressbar" style="width: 85%;max-width: 85%;" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <p class="text-light fw-500 text-start mb-2">JavaScript && jQuery <span class="float-end">80%</span></p>
          <div class="progress progress-sm bg-dark mb-4">
            <div class="progress-bar" role="progressbar" style="width: 80%;max-width: 80%;" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <p class="text-light fw-500 text-start mb-2">C# <span class="float-end">65%</span></p>
          <div class="progress progress-sm bg-dark mb-4">
            <div class="progress-bar" role="progressbar" style="width: 65%;max-width: 65%;" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <p class="text-light fw-500 text-start mb-2">C && C++ <span class="float-end">60%</span></p>
          <div class="progress progress-sm bg-dark mb-4">
            <div class="progress-bar" role="progressbar" style="width: 60%;max-width: 60%;" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <p class="text-light fw-500 text-start mb-2">HTML && CSS && XML <span class="float-end">95%</span></p>
          <div class="progress progress-sm bg-dark mb-4">
            <div class="progress-bar" role="progressbar" style="width: 95%;max-width: 95%;" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

        </div>
      <div  class="col-md-6 my-4" data-aos="fade-up" >


        <p class="text-light fw-500 text-start mb-2">Sql Server && MySql && Sqlite <span class="float-end">90%</span></p>
        <div class="progress progress-sm bg-dark mb-4">
          <div class="progress-bar" role="progressbar" style="width: 90%;max-width: 90%;" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
        </div>

        <p class="text-light fw-500 text-start mb-2">Mongodb && PostgreSQl<span class="float-end">85%</span></p>
        <div class="progress progress-sm bg-dark mb-4">
          <div class="progress-bar" role="progressbar" style="width: 85%;max-width: 85%;" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
        </div>

        <p class="text-light fw-500 text-start mb-2">Bootstrap <span class="float-end">90%</span></p>
        <div class="progress progress-sm bg-dark mb-4">
          <div class="progress-bar" role="progressbar" style="width: 90%;max-width: 90%;" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
        </div>

        <p class="text-light fw-500 text-start mb-2">Angular Js && Vue Js <span class="float-end">70%</span></p>
        <div class="progress progress-sm bg-dark mb-4">
          <div class="progress-bar" role="progressbar" style="width: 70%;max-width: 70%;" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
        </div>

        <p class="text-light fw-500 text-start mb-2">Spring Boot && Spring Microservices<span class="float-end">90%</span></p>
        <div class="progress progress-sm bg-dark mb-4">
          <div class="progress-bar" role="progressbar" style="width: 90%;max-width: 90%;" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
        </div>

        <p class="text-light fw-500 text-start mb-2">Android<span class="float-end">85%</span></p>
        <div class="progress progress-sm bg-dark mb-4">
          <div class="progress-bar" role="progressbar" style="width: 85%;max-width: 85%;" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
        </div>


        <p class="text-light fw-500 text-start mb-2">Laravel<span class="float-end">85%</span></p>
        <div class="progress progress-sm bg-dark mb-4">
          <div class="progress-bar" role="progressbar" style="width: 85%;max-width: 85%;" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
        </div>

        <p class="text-light fw-500 text-start mb-2">Flutter<span class="float-end">70%</span></p>
        <div class="progress progress-sm bg-dark mb-4">
          <div class="progress-bar" role="progressbar" style="width: 70%;max-width: 70%;" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
        </div>

      </div>
      <div  class="col-12 my-2 text-center" data-aos="fade-up">
          <a class="btn btn-outline-primary"  href="cv/CV_Mohammad_Ali.pdf">Download CV <i class="fa-solid fa-file-download ms-2 me-2"></i></a>
      </div>
    </div>

  </div>
  <div class="container-fluid container-swiper">
    <div class="my-3" data-aos="fade-up">
      <VueSwiperAutoplay/>
    </div>

  </div>
</section>
</template>

<script>
import VueSwiperAutoplay from "@/components/VueSwiperAutoplay";
export default {
  name: "VueResume",
  components: {VueSwiperAutoplay}
}
</script>

<style scoped>
.resume{
  padding: 50px 0;
}
.list-education{
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
}
.list-education .card{
  overflow: hidden;
  border: none;
  box-shadow:inset 2px 2px 3px rgba(255,255,255,0.05),
  inset 0 -2px 3px rgba(255,255,255,0.05);
  border-radius: 15px;
  background-color: var(--bg-body);
}
.list-education .card .card-body{
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.list-education .card .date{
  background-color: rgba(71,83,253,0.5);
  color: var(--font-color);
  font-size: 16px;
  font-weight: 500;
  padding: 5px 7px;
  width: max-content;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.list-education .sp-text{
  color: var(--primary-color);
  font-size: 18px;
  font-weight: 500;
}

.list-experience{
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
}

.list-experience .card{
  overflow: hidden;
  border: none;
  box-shadow:inset 2px 2px 3px rgba(255,255,255,0.05),
  inset 0 -2px 3px rgba(255,255,255,0.05);
  border-radius: 15px;
  background-color: var(--bg-body);
}
.list-experience .card .card-body{
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.list-experience .card .date{
  background-color: rgba(71,83,253,0.5);
  color: var(--font-color);
  font-size: 16px;
  font-weight: 500;
  padding: 5px 7px;
  width: max-content;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.list-experience .sp-text{
  color: var(--primary-color);
  font-size: 18px;
  font-weight: 500;
}
.progress-bar{
  background-color: var(--primary-color);

}
.container-swiper{
  max-width: calc(100vw - 95px);
}
@media (max-width: 991px) {
  .container-swiper{
    max-width: 100%;
  }
}
</style>